<template>
  <button :class="{
    'base-button': true,
    'active': active,
    'disabled': disabled,
    'white-button': white,
    'yellow-button': yellow,
    'blue-button': blue,
    'red-button': red
  }" :type="btnType" @click="$emit('clickBtn')" :disabled="disabled || loader">
    <div v-if="loader" class="loading"></div>
    <span v-else>{{ text }}</span>
    <CloseIcon v-if="close" @click="$emit('clickClose')" />
    <PlusIcon v-if="plus" @click="$emit('clickPlus')" />
  </button>
</template>

<script>
import CloseIcon from '@/components/icons/CloseIcon.vue'
import PlusIcon from '@/components/icons/PlusIcon.vue'
export default {
  name: 'BaseBtn',
  components: {
    CloseIcon,
    PlusIcon
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    btnType: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    active: {
      type: Boolean,
      default: () => false
    },
    white: {
      type: Boolean,
      default: false
    },
    yellow: {
      type: Boolean,
      default: false
    },
    blue: {
      type: Boolean,
      default: () => false
    },
    red: {
      type: Boolean,
      default: () => false
    },
    published: {
      type: Boolean,
      default: false
    },
    loader: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: false
    },
    plus: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.base-button {
  position: relative;
  min-width: 90px;
  min-height: 28px;
  font-weight: 500;
  font-size: 20px;
  line-height: 22px;
  color: #FFFFFF;
  background: #848484;
  border-radius: 4px;
  transition: 0.8s;
  cursor: pointer;

  @media(any-hover: hover) {
    &:hover {
      background: #1BA6DA;
      transition: 0.8s;
    }
  }

  &:active {
    background: #1487B1;
    transition: 0.5s;
  }
}

.white-button {
  padding: 8px 15px;
  color: #848484;
  background: #FFFFFF;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  border: 1px solid transparent;
  border-radius: 4px;

  @media(any-hover: hover) {
    &:hover {
      border: 1px solid #1BA6DA;
      background: #FFFFFF;
      transition: 0.5s;
      color: #848484;
    }
  }

  &:active {
    background: #1487B1;
    color: #FFFFFF;
    transition: 0.5s;
  }
}

.yellow-button {
  // padding: 8px 15px;
  color: #595959;
  background: #F4DD02;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  border: 1px solid transparent;
  border-radius: 4px;

  @media(any-hover: hover) {
    &:hover {
      // border: 1px solid #CAB601;
      background: #CAB601;
      transition: 0.5s;
    }
  }

  &:active {
    background: #918202;
    // color: #FFFFFF;
    transition: 0.5s;
  }
}

.blue-button {
  padding: 12px 16px;
  background: #D6F0FA;
  color: #1487B1;

  @media (any-hover: hover) {
    &:hover {
      color: #FFFFFF;

      :deep(svg > path) {
        stroke: #FFFFFF;
        transition: 0.8s;
      }
    }
  }
}

.red-button {
  background: #FADCD6;
  color: #D1381A;

  &:hover {
    background: #D1381A;
    color: #FFFFFF;
  }
}

.active {
  background: #1BA6DA;
  color: #FFFFFF;
}

.disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading {
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 10px);
  /* 50% ширины - пол. шир. лоадера */
  height: 0;
  width: 0;
  padding: 7px;
  border: 3px solid #ccc;
  border-right-color: #888;
  border-radius: 22px;
  animation: rotate 1s infinite linear;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
</style>
